import { Auth } from "aws-amplify";
import { Component, FunctionComponent } from "react";
import { Form, Alert } from "react-bootstrap";
import { RouteComponentProps } from "react-router-dom";
import { IPutShopName } from "../../../client/core";
import { Path, Storage } from "../../../env";
import { Button, icon, variant } from "../../form/Button";

export interface ShopNameState {
    isLoading: boolean;
    name: string;
    error: string;
}

export interface ShopNameProps extends RouteComponentProps {
    coreAPI: IPutShopName;
    auth: typeof Auth;
}

export default class ShopName extends Component<ShopNameProps, ShopNameState> {
    constructor(props: ShopNameProps) {
        super(props);
        this.state = {
            isLoading: false,
            name: "",
            error: "",
        };
    }

    handleChange = (name: string) => {
        this.setState({
            name: name,
        });
    };

    handleSubmit = () => {
        this.setState({
            isLoading: true
        })
        const shopID = localStorage.getItem(Storage.ShopID);
        if (shopID == null) {
            return this.setState({
                error:
                    "Shop could not be found - please navigate back to the shop dashboard to resync",
            });
        }
        if (this.state.name.trim() === "") {
            return this.setState({
                error:
                    "Please enter the name of your shop you wish to trade under",
            });
        }
        this.props.auth.currentSession().then((session) => {
            const token = session.getIdToken().getJwtToken();
            this.props.coreAPI
                .PutShopName({
                    identityToken: token,
                    shopName: this.state.name,
                    shopID: shopID!,
                })
                .then((output) => {
                    if (output.statusCode === 403) {
                        localStorage.removeItem(Storage.ShopID);
                        return this.setState({
                            isLoading: false,
                            error:
                                "You were forbidden to change the shop name - please navigate back to the shop dashboard.",
                        });
                    }
                    return this.props.history.push(Path.RegisterShopContact);
                })
                .catch((err) =>
                    this.setState({
                        isLoading: false,
                        error: err.message,
                    })
                );
        });
    };

    render() {
        const props: ShopNameFormProps = {
            isLoading: this.state.isLoading,
            name: this.state.name,
            error: this.state.error,
            onChange: this.handleChange,
            onSubmit: this.handleSubmit,
        };
        return <ShopNameRegistrationForm {...props} />;
    }
}

export interface ShopNameFormProps {
    isLoading: boolean;
    name: string;
    error: string;
    onChange: (name: string) => void;
    onSubmit: () => void;
}

export const ShopNameRegistrationForm: FunctionComponent<ShopNameFormProps> = (props) => (
    <Form>
        <Alert variant={"danger"} show={props.error !== ""}>
            {props.error}
        </Alert>
        <h1 style={{ marginBottom: "2rem" }}>Enter name</h1>
        <Form.Group>
            <Form.Label>Shop Name</Form.Label>
            <Form.Control
                type="text"
                name={"name"}
                id={"name"}
                onChange={(e) => props.onChange(e.target.value)}
            />
        </Form.Group>
        <Button
            icon={(props.isLoading) ? icon.Spinner : undefined}
            disabled={props.isLoading}
            style={{ width: "100%", marginTop: "2rem" }}
            buttonvariant={variant.Primary}
            name={"Continue"}
            onClick={() => props.onSubmit()}
        />
    </Form >
);
